import { render, staticRenderFns } from "./studentManagementEdit.vue?vue&type=template&id=b3e09aec&scoped=true&"
import script from "./studentManagementEdit.vue?vue&type=script&lang=js&"
export * from "./studentManagementEdit.vue?vue&type=script&lang=js&"
import style0 from "./studentManagementEdit.vue?vue&type=style&index=0&id=b3e09aec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e09aec",
  null
  
)

export default component.exports